import apiClient from "./apiClient";

export const userInfo = (id) => apiClient.get(`/user-info/${id}`);

export const usersWithoutUser = (id) =>
    apiClient.get(`/users-without-user/${id}`);

export const changePassword = (formData) =>
    apiClient.post("/change-password", formData);

export const createUser = (formData) =>
    apiClient.post("/create-user", formData);

export const changeActivity = (formData) =>
    apiClient.post("/change-activity", formData);